<template>
  <TemplateView v-if="pageList.length">
    <v-container>
      <router-view v-if="childPage"/>
      <template v-else>
        <div class="d-flex flex-wrap gap-3 gap-md-5 mb-8">
          <BaseButton
            v-for="(page, p) in pageList"
            :key="'page_' + p"
            :text="page.text"
            style-type="chip"
            :disabled="$route.name === page.toName"
            @click="$router.push({ name: page.toName })"
          />
        </div>
        <router-view/>
      </template>
    </v-container>
  </TemplateView>
  <div v-else>
    <div class="d-flex flex-wrap gap-3 gap-md-5 mb-8">
      <template v-for="(tab, t) in tabList">
        <BaseButton
          v-if="$userCheckAccess({abilities: tab.abilities})"
          :key="'tab_' + t"
          :text="tab.text"
          style-type="chip"
          :disabled="$route.query.tab === tab.tab"
          @click="goToTab({
          name: tab.toName,
          params: { id: $route.params.id },
          query: {
            tab: tab.tab,
            subTab: $route.query.subTab,
            office_page: $route.query.office_page,
            office_limit: $route.query.office_limit,
            address_page: $route.query.address_page,
            address_limit: $route.query.address_limit,
            email_page: $route.query.email_page,
            email_limit: $route.query.email_limit,
            phone_page: $route.query.phone_page,
            phone_limit: $route.query.phone_limit,
            person_page: $route.query.person_page,
            person_limit: $route.query.person_limit,
            grid: $route.query.grid,
            project_page: $route.query.project_page,
            project_limit: $route.query.project_limit,
          },
        })"
        />
      </template>
    </div>
    <template v-for="(tab, t) in tabList">
      <div v-if="$route.query.tab === 'projects' && tab.subTab.length > 0" class="d-flex flex-wrap gap-3 gap-md-5 mb-8 mt-4" :key="'subTabWrapper_' + t">
        <template v-for="(sub, s) in tab.subTab">
          <BaseButton
            v-if="$userCheckAccess({abilities: sub.abilities})"
            :key="'subTab_' + s"
            :text="sub.text"
            style-type="chip"
            :disabled="$route.query.subTab === sub.tab"
            @click="goToTab({
          name: sub.toName,
          params: { id: $route.params.id },
          query: {
            tab: tab.tab,
            subTab: sub.tab,
            office_page: $route.query.office_page,
            office_limit: $route.query.office_limit,
            address_page: $route.query.address_page,
            address_limit: $route.query.address_limit,
            email_page: $route.query.email_page,
            email_limit: $route.query.email_limit,
            phone_page: $route.query.phone_page,
            phone_limit: $route.query.phone_limit,
            person_page: $route.query.person_page,
            person_limit: $route.query.person_limit,
            grid: $route.query.grid,
            project_page: $route.query.project_page,
            project_limit: $route.query.project_limit,
          },
        })"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "BasePagesWrapper",
  props: {
    childPageName: {
      type: Array,
      default: () => {
        return ['Show', 'Create']
      }
    },
    pageList: {
      type: Array,
      default: () => {
        return []
      }
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    childPage() {
      let result = [false]
      for (let i in this.childPageName) {
        result.push(this.$route.name.includes(this.childPageName[i]))
      }
      return result.some(e => e)
    }
  },
  methods: {
    goToTab(data) {
      let local = localStorage.getItem('queryParams')
      local = local ? JSON.parse(localStorage.getItem('queryParams')) : {}
      //local[this.$route.name] = data.query
      if (!local[this.$route.name]) local[this.$route.name] = {}
      local[this.$route.name][this.$route.params.id] = data.query
      localStorage.setItem('queryParams', JSON.stringify(local))
      this.$router.push(data)
    },
  }
}
</script>